var map = {
	"./cash.jpg": "pcTo",
	"./dotpay.png": "oT87",
	"./hotpay.png": "6whO",
	"./imoje.png": "Xtfh",
	"./paynow.png": "Zvep",
	"./paypal.png": "32wF",
	"./payu.jpg": "pecl",
	"./przelewy24.png": "z+2j",
	"./stripe.png": "xzaV",
	"./tpay.png": "XYIP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VTA7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos ^\.\/.*$
// module id = VTA7
// module chunks = 46